export const schoolsConst = {
    LOADED: 'SCHOOLS_LOADED',
    UNLOADED: 'SCHOOLS_UNLOADED',
    ADD_SCHOOL: 'ADD_SCHOOL',
    REMOVE_SCHOOL: 'REMOVE_SCHOOL'
};
